import { StartStockCountFormProvider } from "./StartStockCountFormProvider";
import { NameFormInput } from "./components";

export interface StartStockCountFormProps {}

export const StartStockCountForm = ({}: StartStockCountFormProps) => {
  return null;
};

StartStockCountForm.Provider = StartStockCountFormProvider;
StartStockCountForm.NameFormInput = NameFormInput;
